/// <amd-module name="Repos/Views/Settings/Repositories/Components/RenameDialog" />
import React = require("react");
import { DialogType, IRepository } from "Repos/Views/Settings/Repositories/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories/Resources";
import { IRepositoriesViewService } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import * as Utils from "VSS/Core/Util/String";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { RepositoryDialog } from "./RepositoryDialog";

export class RenameDialog extends VssComponent {
    private repository: IReadonlyObservableValue<IRepository | undefined>;
    private svc: IRepositoriesViewService;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
        this.repository = this.svc.getDialogRepository();
    }

    public render = (): JSX.Element => {
        return (
            <Observer repo={this.repository}>
                {(props: { repo: IRepository | undefined }) => {
                    return props.repo ? (
                        <RepositoryDialog
                            dialogType={DialogType.Rename}
                            message={Resources.RenameMessage}
                            primaryButtonText={Resources.Rename}
                            textboxPlaceholder={Resources.RenamePlaceholder}
                            textBoxInitialValue={props.repo ? props.repo.name : ""}
                            title={Utils.format(Resources.RenameTitle, props.repo.name)}
                            getActionPromise={this.getActionPromise}
                            primaryButtonDisabled={this.primaryButtonDisabled}
                        />
                    ) : null;
                }}
            </Observer>
        );
    };

    private getActionPromise = (textboxValue: string) => {
        return this.svc.renameRepository(this.repository.value as IRepository, textboxValue);
    };

    private primaryButtonDisabled = (text: string) => {
        return (this.repository.value && this.repository.value.name === text) || !text || text.length === 0;
    };
}
